import styled from "styled-components"

const Title = styled.h2`
&::after {
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
}
color: ${(props) => props.theme.c_color_gradients.c_dark};
}
`
export { Title }
